module.exports = __webpack_public_path__ + "static/media/ImageMagick_logo 2.b7e47710.png";